export const TZ_Aстана = 'Asia/Almaty'

export function parseISOToMs(iso: string): number | null {
  if (!iso) return null

  const trimmedFrac = iso.replace(/(\.\d{3})\d+(?=[Z+-])/, '$1').replace(/(\.\d{3})\d+$/, '$1')
  let ts = Date.parse(trimmedFrac)
  if (!Number.isNaN(ts)) return ts

  const noFrac = iso.replace(/\.\d+(?=[Z+-])/, '').replace(/\.\d+$/, '')
  ts = Date.parse(noFrac)
  if (!Number.isNaN(ts)) return ts

  const m = /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2}):(\d{2})(\.\d+)?(Z|([+-])(\d{2}):?(\d{2}))?$/.exec(iso)
  if (!m) return null

  const year = Number(m[1])
  const month = Number(m[2])
  const day = Number(m[3])
  const hour = Number(m[4])
  const minute = Number(m[5])
  const second = Number(m[6])

  const frac = m[7] || ''
  const ms = frac ? Math.round(Number(`0${frac}`) * 1000) : 0

  const utc = Date.UTC(year, month - 1, day, hour, minute, second, ms)
  if (Number.isNaN(utc)) return null

  const tzToken = m[8]
  if (!tzToken || tzToken === 'Z') return utc

  const sign = m[9] === '-' ? -1 : 1
  const offH = Number(m[10] || '0')
  const offM = Number(m[11] || '0')
  const offsetMinutes = sign * (offH * 60 + offM)

  return utc - offsetMinutes * 60_000

  return null
}

export function todayISOInTZ(tz = TZ_Aстана) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date())

  const y = parts.find(p => p.type === 'year')?.value
  const m = parts.find(p => p.type === 'month')?.value
  const d = parts.find(p => p.type === 'day')?.value
  return `${y}-${m}-${d}`
}

export function formatTimeInTZ(iso: string, tz = TZ_Aстана) {
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: tz,
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso))
}
